import React, { Suspense } from 'react';
import { Form, Icon, Input, Button, Card, message, Spin, Modal, Select } from 'antd';
import FooterContainer from '../footer/index'
import InitPage from '../../components/firstInit/index'
import { connect } from 'react-redux';
import request from '../../scripts/request'
import SSAS from '../../scripts/ssas'
import JSEncrypt from 'jsencrypt'
import QRCode from 'qrcode.react';
import 'antd/dist/antd.css';
import './Login.css';
import '../../scripts/config'

let $this;
let store;
const InputGroup = Input.Group;
const { confirm } = Modal;
let LG;
class LoginForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            codeVal: 0,
            codeString: '',
            userDwid: '',
            userName: '',
            userNameCN: '',
            loading: false,
            submitLoading: false,
            passWord: '',
            valCode: '',
            initVisible: false,
            rsaStoken: { jgdata: [] },
            wsobj: {},
            wslink: false,
            loginState: '关闭'
        };
        $this = this;
        store = this.props.store;
    }

    //组建载入完成完成
    componentDidMount() {
        this.codeNumberHandler();
        //初始化秘钥
        request({
            url: 'api/Login/loginRsaLoad',
            method: 'post',
            data: {}
        }, {
            loading: true,
            msg: '秘钥载入中,请稍等'
        }).then(function (res) {
            if (res != null) {
                $this.setState({ rsaStoken: res.data });
                setTimeout(() => {
                    $this.handlerFormInput();
                }, 200);
            }
        });
        this.props.onRef(this);
    }
    //提交
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                //验证码
                if (parseInt(this.state.codeVal) !== parseInt(values.valCode)) {
                    this.codeNumberHandler();
                    message.error('验证码计算错误，请重新输入');
                }
                else {
                    this.setState({ submitLoading: true });
                    //密码提交前加密,避免被明文抓包
                    var encrypt = new JSEncrypt();
                    encrypt.setPublicKey($this.state.rsaStoken.rsaPublic);
                    var enpassWord = encrypt.encrypt(values.passWord);
                    request({
                        url: 'api/Login/LoginSubmit',
                        method: 'post',
                        data: { userName: values.userName, userDwid: values.userDwid, passWord: enpassWord, rsaStoken: $this.state.rsaStoken.rsaStoken }
                    }).then(function (res) {
                        if (res != null) {
                            localStorage.setItem('loginStore', JSON.stringify({ userName: values.userName, userDwid: values.userDwid, userName: values.userName, userNameCN: values.userNameCN }));
                            sessionStorage.removeItem('xzdq_xq_data');//清除地区临时字典
                            if (res.data.url === 'mbPage') {
                                //密保问题
                                $this.setState({ submitLoading: false });

                            }
                            else {
                                $this.loginWrite(res.data);
                            }
                        }
                        else {
                            $this.setState({ submitLoading: false });
                            $this.codeNumberHandler();
                        }
                    });
                }
            }
        });
    };
    //连接状态
    wsObjWrite = (data) => {
        this.setState(data);
    }
    loginWrite = (loginData) => {
        if (LG !== null && LG !== undefined && LG !== '') {
            LG.destroy();
        }
        const { loginHandlerDispatch } = this.props;
        const _user = localStorage.getItem('userStorage');
        let _czy_ksid = '';
        if (_user !== null && _user !== undefined && _user !== '') {
            const _objUser = JSON.parse(_user);
            _czy_ksid = _objUser.czy_ksid;//上次在本机使用的科室
        }
        if (_czy_ksid === '' || _czy_ksid === null || _czy_ksid === undefined) {
            _czy_ksid = loginData.objCzy.ksid;
        }
        let _arrDqid = SSAS.arrDqid(loginData.objCzy);
        let _arrDqidXq = SSAS.arrDqidXq(loginData.objCzy);
        let _objCzy = Object.assign({}, loginData.objCzy, { arrDqid: _arrDqid, arrDqidXq: _arrDqidXq, czy_ksid: _czy_ksid, ksid: _czy_ksid });
        localStorage.setItem('userStorage', JSON.stringify(_objCzy));//操作员数据本地存储
        localStorage.setItem('ssas_access_token', loginData.objCzy.stoken)//令牌存储本地
        let data = { pageName: loginData.url };
        let objPage = localStorage.getItem('objPage');
        if (objPage != '' && objPage != null) {
            data = Object.assign({}, JSON.parse(objPage), { pageName: loginData.url });
        }
        localStorage.setItem('objPage', JSON.stringify(data))//操作页面信息本地存储
        loginHandlerDispatch({ type: 'objUser', data: _objCzy });//更新操作员数据
        loginHandlerDispatch({ type: 'topContainer', data: { pageName: loginData.url } });//更新页面状态
        $this.setState({ submitLoading: false });
        //更新ws状态
        this.props.emitHandler('updatewsobj', { UserType: 'PC', UserId: _objCzy.czyid, UserName: _objCzy.xm, yhid: _objCzy.yhid });
        //无操作监听
        this.props.emitHandler('userHandler', {});
    }
    //数据初始化窗口
    handleInitPageModal = (e) => {
        $this.setState({ initVisible: true });
    }
    initFormRef = formRef => {
        this.formRef = formRef;
    };
    //取消
    inithandleCancel = (e) => {
        if (!this.state.loading) {
            this.setState({ initVisible: false });
        }
        else {
            message.warn('数据初始化中,请勿关闭');
        }
    }
    //开始初始化
    initHandleOk = (e) => {
        const { loginHandlerDispatch } = this.props;
        //const store = this.props.store;
        this.setState({ loading: true });
        if (store.PageInit.dwid !== '') {
            let _data = {};
            _data.dwid = store.PageInit.dwid;
            _data.dwmc = store.PageInit.dwmc;
            _data.yhid = store.PageInit.yhid;
            _data.yhmc = store.PageInit.yhmc;
            _data.dqid = store.PageInit.dqid;
            _data.zcm = store.PageInit.zcm;
            _data.dqfhmc = store.PageInit.dqfhmc;
            this.dataInit(_data, 0, function () {
                loginHandlerDispatch({ type: 'DataLoad', data: { loading: false } });
                //写入本地存储
                localStorage.setItem('loginStore', JSON.stringify({ userName: _data.dwid + '001', userNameCN: '系统管理员' }));
                $this.props.form.setFieldsValue({
                    userName: _data.dwid + '001',
                    userNameCN: '系统管理员',
                    passWord: 'abcd'
                });
                $this.setState({ loading: false });
                Modal.confirm({
                    content: '初始化完毕,是否需要查看初始化日志?',
                    icon: <Icon type='question-circle'></Icon>,
                    okText: '查看',
                    cancelText: '不用了',
                    onOk: $this.dataInitRzGrid,
                    onCancel: $this.initConfirmCancel
                });
            })
        }
        else {
            message.warn('请输入正确的注册码并验证机构信息');
        }
    }
    //数据初始化
    dataInit = (_data, index, fn) => {
        const { loginHandlerDispatch } = $this.props;
        //let store = this.props.store;
        loginHandlerDispatch({ type: 'DataLoad', data: { current: index, status: 'process' } });
        _data.tbName = 'setp' + (index + 1).toString();
        request({
            url: 'api/DataInit/dataInit',
            method: 'post',
            data: _data
        }).then(function (res) {
            if (res !== null) {
                let _resdata = { current: parseInt(res.data.current), status: res.data.status };
                if (index === 0) {
                    _resdata.description1 = res.data.stepMsg;
                }
                else if (index === 1) {
                    _resdata.description2 = res.data.stepMsg;
                }
                else if (index === 2) {
                    _resdata.description3 = res.data.stepMsg;
                }
                else if (index === 3) {
                    _resdata.description4 = res.data.stepMsg;
                }
                else if (index === 4) {
                    _resdata.description5 = res.data.stepMsg;
                }
                else if (index === 5) {
                    _resdata.description6 = res.data.stepMsg;
                }
                else if (index === 6) {
                    _resdata.description7 = res.data.stepMsg;
                }
                loginHandlerDispatch({ type: 'DataLoad', data: _resdata });
                if (index < 7) {
                    index++;
                    $this.dataInit(_data, index, fn);
                }
                else {
                    if (fn != null && fn != undefined) {
                        fn();
                    }
                }
            }
        });
    }
    //conifrm
    initConfirmCancel = () => {
        this.setState({ initVisible: false });
    }
    //查看初始化日志
    dataInitRzGrid = () => {
        //打开列表
        const LayzPage = React.lazy(() => import('../../components/firstInit/initGrid.js'));
        Modal.info({
            title: '数据初始化日志信息',
            icon: <Icon type="ordered-list"></Icon>,
            okText: '关闭',
            width: '600px',
            okButtonProps: { loading: $this.state.loading },
            onOk: this.handleIniOkClick,
            content: <Suspense fallback={<Spin size="large" />}><LayzPage yhid={store.PageInit.yhid} /></Suspense>,
        });
        setTimeout(() => {
            this.setState({ initVisible: false });
        }, 500);

    }
    //输入框键盘事件
    handleKeyPress = e => {
        if (e.which === 13) {
            if (e.target.name === 'valCode') {
                this.handleSubmit(e);
            }
            else if (e.target.name === 'userName') {
                const _userDwid = this.props.form.getFieldValue('userDwid');
                if (_userDwid !== '' && _userDwid !== null && _userDwid !== undefined) {
                    //获取操作员姓名
                    request({
                        url: 'api/Login/loginLoadXm',
                        method: 'post',
                        data: { userName: e.target.value, userDwid: _userDwid }
                    }).then(function (res) {
                        if (res !== null && res !== undefined) {
                            $this.setState({ userNameCN: res.data.userNameCN, userNameFocus: false, passWordFocus: false });
                            $this.props.form.setFieldsValue(res.data);
                        }
                        else {
                            message.error('接口访问失败');
                        }
                    });
                }
                else {
                    message.error('请先选择单位');
                }
            }
        }
    }
    //输入项检测
    handlerOnChange = e => {
        if (e.target.name === 'valCode') {
            const reg = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;
            if ((!isNaN(e.target.value) && reg.test(e.target.value)) || e.target.value === '' || e.target.value === '-') {
                this.setState({
                    [e.target.name]: e.target.value
                });
            }
            else {
                setTimeout(() => {
                    this.props.form.setFieldsValue({
                        valCode: '',
                    });
                }, 100);
            }
        }
        else {
            this.setState({
                [e.target.name]: e.target.value
            });
            if (e.target.name === 'userName') {
                this.props.form.setFieldsValue({
                    userNameCN: '',
                });
            }
        }
    }

    //验证码更新
    codeNumberHandler = () => {
        this.props.form.setFieldsValue({
            passWord: '',
            valCode: '',
        });
        const _index = Math.round(Math.random());
        let num1 = Math.floor(Math.random() * 100);
        let num2 = Math.floor(Math.random() * 10);
        if (_index === 0) {
            let result = num1 + num2;
            this.setState({ codeVal: result, codeString: num1.toString() + '+' + num2.toString() });
        }
        else {
            let result = num1 - num2;
            this.setState({ codeVal: result, codeString: num1.toString() + '-' + num2.toString() });
        }

    }
    //填充初始值
    handlerFormInput = () => {
        const _objUser = this.props.objUser;
        if (_objUser !== undefined) {
            if (_objUser.username !== '' && _objUser.username !== null && _objUser.username !== undefined)
                this.props.form.setFieldsValue({
                    userDwid: _objUser.userDwid || '',
                    userName: _objUser.userName || '',
                    userNameCN: _objUser.userNameCN || '',
                    passWord: ''
                });
        }
        else {
            let obj = localStorage.getItem('loginStore');
            if (obj !== '' && obj !== null && obj !== undefined) {
                let loginMsg = JSON.parse(obj);
                this.props.form.setFieldsValue({
                    userDwid: loginMsg.userDwid,
                    userName: loginMsg.userName,
                    userNameCN: loginMsg.userNameCN,
                    passWord: ''
                });
            }
        }
    }
    //清除本地数据
    localStorageClear = () => {
        confirm({
            content: '确定要清除本地存储的数据?',
            onOk() {
                //本地存储数据清除
                let ar = ['ssas_access_token', 'objPge', 'indexPageSuccess', 'indexPageSuccessTime', 'homePageSuccess', 'DictionariesSjzd', 'DictionariesXtsz', 'DictionariesRydm', 'DictionariesKsRydm', 'DictionariesXzdq', 'DictionariesXzdqXq', 'DictionariesDwdm', 'DictionariesDwdmXq', 'DictionariesState'];
                ar.map((obj, index) => {
                    localStorage.setItem(obj, '');
                });
                message.success('数据清理完成');
            }
        });
    }
    //扫码登录
    scanLogin = () => {
        if (this.state.wslink) {
            const _str = 'ssas_scan_login_tb;' + this.state.wsobj.ClientId + ';' + this.state.wsobj.ClientIpAddress + ';' + this.state.wsobj.ClientPort;
            LG = Modal.info({
                title: '请用移动工作端扫码二维码',
                maskClosable: true,
                content: <div style={{ padding: '10px' }}>
                    <QRCode
                        value={_str}  //value参数为生成二维码的链接
                        size={260} //二维码的宽高尺寸
                        fgColor="#000000"  //二维码的颜色
                    />
                </div>,
                okText: $this.state.loginState,
                okButtonProps: { icon: 'close', type: 'danger' },
                onOk: () => { }
            });
        }
        else {
            message.error('通信服务器未连接,当前功能无法使用');
        }
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        //let initstore = this.props.store;
        return (
            <Suspense fallback={<Spin size="large" />}>
                <div className="login-container">
                    <a href="javascript:void(0);" onClick={this.localStorageClear.bind(this)} style={{ top: '5px', right: '20px', position: 'absolute', color: 'black', fontSize: '14px' }} title="点击清除本地存储数据"><Icon type="delete"></Icon>清空本地数据</a>
                    <Card className="login-card"
                        cover={
                            <div className="login-card-header" onClick={() => this.scanLogin()}>{global.constants.yynam}<Icon type="qrcode" title={this.state.wslink ? '扫码登录' : '通信服务器连接失败'} className='login-card-hear-icon' style={this.state.wslink ? { color: 'black' } : { color: '#DBDAE2' }}></Icon></div>
                        }
                    >
                        <Form className="login-form">
                            <Form.Item>
                                {getFieldDecorator('userDwid', {
                                    rules: [{ required: true, message: '请选择机构' }],
                                })(
                                    <Select
                                        showSearch
                                        type="userDwid"
                                        name='userDwid'
                                        placeholder="请选择机构"
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {
                                            this.state.rsaStoken.jgdata.map(item => {
                                                return <Select.Option value={item.value}>{item.label}</Select.Option>
                                            })
                                        }
                                    </Select>,
                                )}
                            </Form.Item>
                            <Form.Item>
                                <InputGroup compact>
                                    {getFieldDecorator('userName', {
                                        rules: [{ required: true, message: '请输入用户名!' }],
                                    })(
                                        <Input
                                            prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            placeholder="用户名/联系电话/邮箱"
                                            name='userName'
                                            autoComplete='off'
                                            style={{ width: '60%' }}
                                            autoFocus={true}
                                            allowClear
                                            onChange={this.handlerOnChange.bind(this)}
                                            onPressEnter={this.handleKeyPress}
                                        />
                                    ,
                                    )}
                                    {getFieldDecorator('userNameCN')(
                                        <Input style={{ width: '40%' }} name='userNameCN' placeholder="姓名(自动识别)" autoComplete='off' allowClear />
                                    ,
                                    )}
                                </InputGroup>
                            </Form.Item>
                            <Form.Item>
                                {getFieldDecorator('passWord', {
                                    rules: [{ required: true, message: '请输入密码!' }],
                                })(
                                    <Input
                                        prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        type="password"
                                        name='passWord'
                                        allowClear
                                        placeholder="用户密码"
                                        autoComplete='off'
                                    />,
                                )}
                            </Form.Item>
                            <Form.Item>
                                <div className="login-form-val">
                                    {getFieldDecorator('valCode', {
                                        rules: [{ required: true, message: '请输入验证码!' }],
                                    })(
                                        <Input
                                            precision={1}
                                            prefix={<Icon type="calculator" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                            name='valCode'
                                            style={{ width: '100%' }}
                                            placeholder="请输入右侧计算结果"
                                            onPressEnter={this.handleKeyPress.bind(this)}
                                        />,
                                    )}
                                </div>
                                <div className="login-form-number word glitch" onClick={this.codeNumberHandler}>
                                    <div className="flash is-off"><span className="text">{this.state.codeString}</span></div>
                                </div>
                            </Form.Item>
                            <Form.Item>
                                <Button type="danger" className="login-form-button" loading={this.state.submitLoading} onClick={this.handleSubmit.bind(this)}>登录</Button>
                            </Form.Item>
                            <Form.Item>
                                <a href="javascript:void(0);" style={{ color: 'white' }} onClick={this.handleInitPageModal}>初始化系统</a>
                                <a className="login-form-forgot" style={{ color: 'white' }} href="">忘记密码?</a>
                            </Form.Item>
                        </Form>
                    </Card>
                    <FooterContainer></FooterContainer>
                    <div className='fontClass'>
                        <div className='fontClassCN'>{global.constants.yynam}</div>
                        <div className='fontClassEN'>{global.constants.yynamen}</div>
                    </div>
                </div>
                {/****初始化弹窗****/}
                <Modal
                    title={<div><Icon type="setting"></Icon>&nbsp;&nbsp;系统初始化</div>}
                    closable={false}
                    visible={this.state.initVisible}
                    onOk={this.initHandleOk}
                    okText='初始化'
                    cancelText='关闭'
                    onCancel={this.inithandleCancel}
                    confirmLoading={this.state.loading}
                    destroyOnClose={true}
                >
                    <InitPage setpMsg={this.state.setpMsg}></InitPage>
                </Modal>
            </Suspense>
        );
    }
}

//需要渲染什么数据
function mapStateToProps(state) {
    return {
        store: state
    }
}
//需要触发什么行为
function mapDispatchToProps(dispatch) {
    return {
        loginHandlerDispatch: (par) => dispatch(
            {
                type: par.type, data: par.data
            }
        )
    }
}
let WrappedNormalLoginForm = Form.create({ name: 'normal_login' })(LoginForm);
//连接组件
WrappedNormalLoginForm = connect(mapStateToProps, mapDispatchToProps)(WrappedNormalLoginForm)
export default WrappedNormalLoginForm;